import { PRODUCT_PRICING_STATES } from '@app/api/constants'

import type { ObjectValuesType } from '@app/types'

export const PRODUCT_PRICING_STATES_TITLE: Record<ObjectValuesType<typeof PRODUCT_PRICING_STATES>, string> = {
  [PRODUCT_PRICING_STATES.DONE]: 'отправлено',
  [PRODUCT_PRICING_STATES.PENDING]: 'ожидание',
  [PRODUCT_PRICING_STATES.PROCESSING]: 'обработка'
} as const
